import { Box, Grid, Stack, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import Translate from "../../utils/Translate";
import TooltipFields from "../TooltipFields";
import DotMenu from "../DotMenu";
import { formatDate } from "../../utils/dateTimeFormat";

export default function StUnitField({
  qty,
  isUnlimitedQty,
  locationAreaName,
  blocked,
  revision,
  printing,
  pcsPrice,
  fifoDate,
  dotMenuActions,
  small,
}) {
  return (
    <Stack
      className={"stUnitField" + (dotMenuActions ? " withMenu" : "") + (small ? " small" : "")}
      direction="row"
      spacing={1}
      alignItems="center"
    >
      <Tooltip
        title={
          <TooltipFields
            fields={[
              {
                label: Translate.get("Quantity"),
                value: isUnlimitedQty ? "∞" : qty,
              },
              {
                label: Translate.get("StUnitAreaLabel"),
                value: locationAreaName ?? "-",
              },
              {
                label: Translate.get("StUnitPrintingLabel"),
                value: printing ?? "-",
              },
              {
                label: Translate.get("StUnitRevisionLabel"),
                value: revision ?? "-",
              },
              {
                label: `${Translate.get("StUnitTotalValueLabel")} (${Translate.get("PieceShort").toLowerCase()})`,
                value: `${pcsPrice ?? 0} kr`,
              },
              {
                label: `${Translate.get("StUnitTotalValueLabel")} (${Translate.get("TotalSum").toLowerCase()})`,
                value: `${(pcsPrice ?? 0) * (qty ?? 0)} kr`,
              },
              {
                label: Translate.get("StUnitFifoDate"),
                value: fifoDate ? formatDate(fifoDate) : "-",
              },
              {
                label: Translate.get("Status"),
                value: blocked ? Translate.get("StUnitStatusBlocked") : Translate.get("Ok"),
              },
            ]}
            width="200px"
          />
        }
        arrow
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Box className={"stUnitStatus " + (blocked ? "blocked" : "ok")}></Box>
          <Box>{isUnlimitedQty ? "∞" : qty}</Box>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
            }}
          >
            {locationAreaName ?? "??"}
          </Typography>
        </Stack>
      </Tooltip>
      {dotMenuActions && <DotMenu content={dotMenuActions} horizontal />}
    </Stack>
  );
}
